import Script from 'next/script'
import React from 'react'
import { useAccount } from 'wagmi'
import { META_CRM_SCRIPT } from 'constants/inlineScripts'
import { env } from 'env.client'

type MetaCRMProviderProps = React.PropsWithChildren<{
  nonceHeader: string
}>

export const MetaCRMProvider = ({ nonceHeader, children }: MetaCRMProviderProps) => {
  const { address } = useAccount()

  React.useEffect(() => {
    const connectMetaCRM = () => {
      window.MetaCRMWidget?.manualConnectWallet?.(address)
    }

    connectMetaCRM()
    document.addEventListener('MetaCRMLoaded', connectMetaCRM)

    return () => document.removeEventListener('MetaCRMLoaded', connectMetaCRM)
  }, [address])

  return (
    <>
      {process.env.NODE_ENV === 'production' &&
        env.NEXT_PUBLIC_META_CRM_API_KEY &&
        env.NEXT_PUBLIC_META_CRM_TRACKING_TAG_API_KEY && (
          <>
            <Script
              id="meta-crm-script"
              dangerouslySetInnerHTML={{
                __html: META_CRM_SCRIPT,
              }}
              strategy="lazyOnload"
              nonce={nonceHeader}
            />

            <Script
              id="metacrm-tracking"
              src="https://attribution.metacrm.inc/tracking-1-3-0.js"
              data-entity-id="669fbf55a5ffc4d2fb303d95"
              crossOrigin="anonymous"
              data-api-key={env.NEXT_PUBLIC_META_CRM_TRACKING_TAG_API_KEY}
              data-eco-systems='{"evm":true}'
              integrity="sha384-LkepA/fAsOX6JggmmktPy4V6KRGi3EikCz4BG7xdtZ57IlczJNRzUz6L/j4+97wD"
              // This is a tracking script, so we want to load it after the page has become interactive to maintain performance
              strategy="afterInteractive"
              nonce={nonceHeader}
            />
          </>
        )}
      {children}
    </>
  )
}
